angular.module('SpidApp')

.constant('ZoneAffranchissementAdapterConfig', {
  name : 'ZoneAffranchissement',
  fields : [
    {
    	local   : 'id_zone',
    	distant : 'id_zone'
    }, {
    	local   : 'code_affranchissement',
    	distant : 'code_affranchissement'
    }, {
    	local   : 'prix_complementaire',
    	distant : 'prix_complementaire'
    }, {
    	local   : 'poids_complementaire',
    	distant : 'poids_complementaire'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'deleted_at',
    	distant : 'deleted_at'
    }, {
	  	local   : 'seuil',
	  	distant : 'seuil'
  	}
  ]
})
